import action from "../commons/providerActionStatus";

export const getProviderDetailsRequestAction = () => {
  return {
    type: action.GET_PROVIDER_DETAILS_REQUEST,
    status: "GET_PROVIDER_DETAILS_REQUEST",
    requestState: true,
  };
};

export const getProviderDetailsSuccessAction = (result) => {
  return {
    type: action.GET_PROVIDER_DETAILS_SUCCESS,
    status: "Provider details retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getProviderDetailsFailureAction = (error) => {
  return {
    type: action.GET_PROVIDER_DETAILS_FAILURE,
    status: "Get PROVIDER details failure",
    error,
    requestState: false,
  };
};


export const updateProviderDataRequestAction = (body) => {
  return {
    type: action.UPDATE_PROVIDER_DETAILS_REQUEST,
    status: "UPDATE_PROVIDER_HISTORY_REQUEST",
    requestState: true,
    payload: {
      body,
    },
  };
};

export const updateProviderDataSuccessAction = (result) => {
  return {
    type: action.UPDATE_PROVIDER_DETAILS_SUCCESS,
    status: "Provider details updated sucessfully",
    result,
    requestState: false,
  };
};

export const updateProviderDataFailureAction = (error) => {
  return {
    type: action.UPDATE_PROVIDER_DETAILS_FAILURE,
    status: "update Provider failure",
    error,
    requestState: false,
  };
};